import { Box, Heading, Text, Input, VStack, HStack, Button } from "@chakra-ui/react";


export default function WartungsprotokollSeite2({ form, setForm }) {

    if (!form) return null;

    const handle = (field, val) => {
        setForm(prev => ({ ...prev, [field]: val }));
    };

    const updateArbeitszeit = (index, field, value) => {
        const copy = [...form.arbeitszeiten];
        copy[index][field] = value;
        setForm(prev => ({ ...prev, arbeitszeiten: copy }));
    };

    const addRow = () => {
        setForm(prev => ({
            ...prev,
            arbeitszeiten: [...prev.arbeitszeiten,
            { datum: "", name: "", beginn: "", ende: "", stunden: "", wetter: "", temperatur: "" }
            ]
        }));
    };

    return (
        <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
            <Heading size="md" mb={6}>Wartungsprotokoll</Heading>

            <VStack align="stretch" spacing={10}>

                {/* Zugangsschlüssel */}
                <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="700px" mt={3} mb={5}>
                    <Text fontWeight="bold">Zugangsschlüssel</Text>
                    <HStack mt={2} spacing={4}>
                        <label>
                            <input
                                type="checkbox"
                                checked={form.zugangsschluesselVorhanden}
                                onChange={e => handle("zugangsschluesselVorhanden", e.target.checked)}
                            />{" "}
                            Vorhanden
                        </label>
                        <Input
                            width="290px"
                            placeholder="Anmerkung"
                            value={form.zugangsschluesselAnmerkung}
                            onChange={e => handle("zugangsschluesselAnmerkung", e.target.value)}
                        />
                    </HStack>
                </Box>

                {/* Thermografiekamera */}
                <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="700px" mt={3} mb={5}>
                    <Text fontWeight="bold">Thermografiekamera für Wartungsarbeiten</Text>
                    <HStack mt={2} spacing={4}>
                        <label>
                            <input
                                type="checkbox"
                                checked={form.thermoKameraVorhanden}
                                onChange={e => handle("thermoKameraVorhanden", e.target.checked)}
                            />{" "}
                            Vorhanden
                        </label>
                        <Input
                            width="290px"
                            placeholder="Anmerkung"
                            value={form.thermoKameraAnmerkung}
                            onChange={e => handle("thermoKameraAnmerkung", e.target.value)}
                        />
                    </HStack>
                </Box>

                {/* Vorgehensweise vor Abfahrt */}
                <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="700px" mt={3} mb={5}>
                    <Text fontWeight="bold">Vorgehensweise – vor Abfahrt</Text>

                    <VStack align="stretch" mt={3} spacing={4}>
                        {/* Betreiber kontaktiert */}
                        <HStack>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={form.betreiberKontaktiert}
                                    onChange={e => handle("betreiberKontaktiert", e.target.checked)}
                                />{" "}
                                Anlagenbetreiber wurde kontaktiert
                            </label>
                            <Input
                                width="290px"
                                placeholder="Anmerkung"
                                value={form.betreiberAnmerkung}
                                onChange={e => handle("betreiberAnmerkung", e.target.value)}
                            />
                        </HStack>

                        {/* Eigentümer kontaktiert */}
                        <HStack>
                            <label>
                                <input
                                    type="checkbox"
                                  checked={form.eigentuemerKontaktiert}
                                  onChange={e => handle("eigentuemerKontaktiert", e.target.checked)}
                                />{" "}
                                Grundstückseigentümer kontaktiert <span>(Zugang)</span>
                            </label>
                            <Input
                                width="290px"
                                placeholder="Anmerkung"
                                value={form.eigentuemerAnmerkung}
                                onChange={e => handle("eigentuemerAnmerkung", e.target.value)}
                            />
                        </HStack>
                    </VStack>
                </Box>

                {/* Elektrofachkraft */}
                <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="400px" mt={3} mb={5}>
                    <Text fontWeight="bold">Verantwortliche ausführende Elektrofachkraft</Text>
                    <Input
                        width="250px"
                        mt={2}
                        placeholder="Name"
                        value={form.elektrofachkraftName}
                        onChange={e => handle("elektrofachkraftName", e.target.value)}
                    />
                </Box>

                {/* Arbeitszeiten */}
                <Box>
                    <Text fontWeight="bold">Arbeitszeiten (pro Tag 1 Zeile)</Text>

                    <VStack align="stretch" spacing={3} mt={4}>
                        {form.arbeitszeiten.map((row, index) => (
                            <HStack key={index} spacing={2}>
                                <Input w="140px" placeholder="Datum"
                                    value={row.datum}
                                    onChange={e => updateArbeitszeit(index, "datum", e.target.value)} />
                                <Input w="160px" placeholder="Name"
                                    value={row.name}
                                    onChange={e => updateArbeitszeit(index, "name", e.target.value)} />
                                <Input w="100px" placeholder="Beginn"
                                    value={row.beginn}
                                    onChange={e => updateArbeitszeit(index, "beginn", e.target.value)} />
                                <Input w="100px" placeholder="Ende"
                                    value={row.ende}
                                    onChange={e => updateArbeitszeit(index, "ende", e.target.value)} />
                                <Input w="80px" placeholder="Std."
                                    value={row.stunden}
                                    onChange={e => updateArbeitszeit(index, "stunden", e.target.value)} />
                                <Input w="120px" placeholder="Wetter"
                                    value={row.wetter}
                                    onChange={e => updateArbeitszeit(index, "wetter", e.target.value)} />
                                <Input w="120px" placeholder="Temperatur"
                                    value={row.temperatur}
                                    onChange={e => updateArbeitszeit(index, "temperatur", e.target.value)} />
                            </HStack>
                        ))}

                        <Button mt={2} onClick={addRow}>+ Zeile hinzufügen</Button>
                    </VStack>
                </Box>

            </VStack>
        </Box>
    );
}